/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useMemo } from 'react';
import { useEntryPointButtonTrigger } from '@jira/platform__entry-point-button-trigger/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import type { EntryPointActions } from '@jira/platform__entry-point/src/controllers/utils/types.tsx';

export type HoverEntryPointTrigger = (element: HTMLElement | null) => void;

export const useHoverEntryPointTrigger = (
	actions: EntryPointActions,
	isActive = true,
): HoverEntryPointTrigger => {
	const eventMap = useMemo(
		() => ({
			mouseenter: actions.load,
			focusin: actions.load,
		}),
		[actions],
	);

	return useEntryPointButtonTrigger(actions, isActive, eventMap);
};
